import { render, staticRenderFns } from "./AStatusText.vue?vue&type=template&id=f452760a"
import script from "./AStatusText.vue?vue&type=script&lang=js"
export * from "./AStatusText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports